import React from 'react';

const BASE = 'https://www.pinpointfieldservices.com';

const marketsByState = [
  {
    state: 'Arizona',
    cities: [{ name: 'Phoenix', slug: 'arizona/phoenix' }],
  },
  {
    state: 'Arkansas',
    cities: [{ name: 'Little Rock', slug: 'arkansas/little-rock' }],
  },
  {
    state: 'California',
    cities: [
      { name: 'San Diego', slug: 'california/san-diego' },
      { name: 'San Francisco', slug: 'california/san-francisco' },
    ],
  },
  {
    state: 'Colorado',
    cities: [{ name: 'Denver', slug: 'colorado/denver' }],
  },
  {
    state: 'District of Columbia',
    cities: [{ name: 'Washington', slug: 'district-of-columbia/washington' }],
  },
  {
    state: 'Florida',
    cities: [
      { name: 'Jacksonville', slug: 'florida/jacksonville' },
      { name: 'Miami', slug: 'florida/miami' },
      { name: 'Orlando', slug: 'florida/orlando' },
    ],
  },
  {
    state: 'Hawaii',
    cities: [{ name: 'Honolulu', slug: 'hawaii/honolulu' }],
  },
  {
    state: 'Illinois',
    cities: [{ name: 'Chicago', slug: 'illinois/chicago' }],
  },
  {
    state: 'Iowa',
    cities: [
      { name: 'Davenport', slug: 'iowa/davenport' },
      { name: 'Des Moines', slug: 'iowa/des-moines' },
      { name: 'Iowa City', slug: 'iowa/iowa-city' },
    ],
  },
  {
    state: 'Maryland',
    cities: [{ name: 'Baltimore', slug: 'maryland/baltimore' }],
  },
  {
    state: 'Minnesota',
    cities: [{ name: 'Minneapolis', slug: 'minnesota/minneapolis' }],
  },
  {
    state: 'Missouri',
    cities: [{ name: 'Kansas City', slug: 'missouri/kansas-city' }],
  },
  {
    state: 'Nebraska',
    cities: [
      { name: 'Lincoln', slug: 'nebraska/lincoln' },
      { name: 'Omaha', slug: 'nebraska/omaha' },
    ],
  },
  {
    state: 'Nevada',
    cities: [{ name: 'Las Vegas', slug: 'nevada/las-vegas' }],
  },
  {
    state: 'North Carolina',
    cities: [{ name: 'Winston-Salem', slug: 'north-carolina/winston-salem' }],
  },
  {
    state: 'Oklahoma',
    cities: [
      { name: 'Oklahoma City', slug: 'oklahoma/oklahoma-city' },
      { name: 'Tulsa', slug: 'oklahoma/tulsa' },
    ],
  },
  {
    state: 'Texas',
    cities: [
      { name: 'Dallas', slug: 'texas/dallas' },
      { name: 'Fort Worth', slug: 'texas/fort-worth' },
      { name: 'San Antonio', slug: 'texas/san-antonio' },
    ],
  },
  {
    state: 'Utah',
    cities: [{ name: 'Salt Lake City', slug: 'utah/salt-lake-city' }],
  },
  {
    state: 'Wyoming',
    cities: [{ name: 'Cheyenne', slug: 'wyoming/cheyenne' }],
  },
];

const stateAbbr = {
  'Arizona': 'AZ', 'Arkansas': 'AR', 'California': 'CA', 'Colorado': 'CO',
  'District of Columbia': 'DC', 'Florida': 'FL', 'Hawaii': 'HI', 'Illinois': 'IL',
  'Iowa': 'IA', 'Maryland': 'MD', 'Minnesota': 'MN', 'Missouri': 'MO',
  'Nebraska': 'NE', 'Nevada': 'NV', 'North Carolina': 'NC', 'Oklahoma': 'OK',
  'Texas': 'TX', 'Utah': 'UT', 'Wyoming': 'WY',
};

const HomepageMarkets = () => (
  <section style={{ backgroundColor: '#fff', padding: '3rem 0', borderTop: '1px solid #e2e8f0' }}>
    <div className="container">
      <div className="text-center mb-2">
        <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#1a202c' }}>
          Nationwide coverage. Established closers in 28 major metros.
        </h2>
        <p style={{ color: '#4a5568', marginBottom: '0.5rem' }}>
          We cover closings in all 50 states. In these markets, we have closers we've worked with repeatedly.
        </p>
        <p style={{ color: '#4a5568', marginBottom: '2rem' }}>
          Closers we know in each market. Confirmed within the hour.
        </p>
      </div>

      <div className="row">
        {marketsByState.map(({ state, cities }) => (
          <div key={state} className="col-6 col-md-4 col-lg-3" style={{ marginBottom: '1.75rem' }}>
            <p style={{ fontSize: '0.75rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#718096', marginBottom: '0.4rem' }}>
              {state}
            </p>
            {cities.map(({ name, slug }) => (
              <a
                key={name}
                href={`${BASE}/mobile-notary/${slug}/`}
                style={{ display: 'block', fontSize: '0.9rem', color: '#2d3748', textDecoration: 'none', lineHeight: '1.9' }}
                onMouseEnter={e => e.currentTarget.style.color = '#00bfff'}
                onMouseLeave={e => e.currentTarget.style.color = '#2d3748'}
              >
                {name}, {stateAbbr[state]}
              </a>
            ))}
          </div>
        ))}
      </div>

      <div className="text-center mt-5">
        <a
          href={`${BASE}/mobile-notary/`}
          style={{ color: '#00bfff', fontWeight: '600', fontSize: '0.95rem', textDecoration: 'none' }}
        >
          See all 28 cities →
        </a>
      </div>
    </div>
  </section>
);

export default HomepageMarkets;
